export default __webpack_public_path__ + "static/Ipiranga-05e17e5c01a0d426fd41338630cb0f26.svg";